import { Component, Input } from "@angular/core";

@Component({
  selector: "app-card",
  standalone: true,
  templateUrl: "./CardComponent.html",
  styleUrl: "./CardComponent.scss",
})
export class AppCardComponent {
  @Input() padded = true;
}
